import React from "react"

/* Import Local Styles */
import "../icon.css"

const HeartSvg = () => (
  <svg
    className="icon no-fill"
    viewBox="0 0 32 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.1328 0.733128C18.547 -2.33464 16.1381 6.7015 16.1381 6.7015C16.1381 6.7015 15.1377 3.3191 11.9616 1.64756C10.4755 0.860952 8.51343 0.457816 5.9492 0.939612C-2.06404 2.47349 1.4715 9.73977 1.4715 9.73977C1.4715 9.73977 2.53022 10.4969 3.08386 10.9393C3.62779 11.3818 4.17172 11.8046 4.69622 12.2077C6.93021 14.0759 9.05736 16.1506 11.0777 18.4318C13.098 20.7228 14.788 22.9744 16.1479 25.1966C17.4591 22.9744 19.1298 20.7228 21.1501 18.4318C23.1704 16.1408 25.2975 14.0661 27.5315 12.2077C28.1046 11.8046 28.6485 11.3818 29.173 10.9393C29.6975 10.4969 30.222 10.0937 30.7562 9.73977C30.7465 9.73977 33.7187 3.79106 26.1328 0.733128ZM20.7324 15.5901C19.7514 17.1437 18.1682 19.1102 15.9925 21.4995C13.7682 19.1102 12.1558 17.1437 11.1748 15.5901C10.1938 14.0366 7.50328 10.428 6.18231 8.24522C6.18231 8.24522 4.15229 5.18728 7.32844 3.64357C11.068 1.82454 15.9925 9.08098 15.9925 9.08098C15.9925 9.08098 19.0909 2.17852 23.1704 3.75173C25.9289 4.80381 25.9483 6.2787 25.6569 7.13413C25.5209 7.33079 25.4044 7.55693 25.3072 7.82241C25.0838 8.4517 21.7231 14.0366 20.7324 15.5901Z"
      className="fill-with-text-color"
    />
  </svg>
)

export default HeartSvg
